var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountrysetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.66602 4.46866H6.29102M9.49935 4.46866H8.04102M6.29102 4.46866H8.04102M6.29102 4.46866V3.66406M8.04102 4.46866C7.73331 5.569 7.08897 6.60915 6.35352 7.52326M4.47852 9.4974C5.07304 8.9507 5.74451 8.28019 6.35352 7.52326M6.35352 7.52326C5.97852 7.0836 5.45352 6.37227 5.30352 6.05043M6.35352 7.52326L7.47852 8.6928",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.35128 13.6455C5.39664 15.0789 5.55266 15.9581 6.08931 16.612C6.22783 16.7808 6.38259 16.9356 6.55137 17.0741C7.47333 17.8307 8.84311 17.8307 11.5827 17.8307C14.3223 17.8307 15.692 17.8307 16.614 17.0741C16.7828 16.9356 16.9375 16.7808 17.0761 16.612C17.8327 15.6901 17.8327 14.3203 17.8327 11.5807C17.8327 8.84116 17.8327 7.47138 17.0761 6.54942C16.9375 6.38064 16.7828 6.22588 16.614 6.08736C15.9629 5.55303 15.0885 5.39604 13.666 5.34992M5.35128 13.6455C3.91783 13.6001 3.03862 13.4441 2.3847 12.9074C2.21592 12.7689 2.06116 12.6142 1.92265 12.4454C1.16602 11.5234 1.16602 10.1536 1.16602 7.41406C1.16602 4.67449 1.16602 3.30471 1.92265 2.38275C2.06116 2.21397 2.21592 2.05921 2.3847 1.92069C3.30666 1.16406 4.67645 1.16406 7.41602 1.16406C10.1556 1.16406 11.5254 1.16406 12.4473 1.92069C12.6161 2.05921 12.7709 2.21397 12.9094 2.38275C13.446 3.03667 13.6021 3.91587 13.6474 5.34932C13.6474 5.34932 13.6474 5.34932 13.666 5.34992M5.35128 13.6455L13.666 5.34992",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4746",
    d: "M10.332 15.3281L11.0265 13.6615M14.4987 15.3281L13.8043 13.6615M11.0265 13.6615L12.4154 10.3281L13.8043 13.6615M11.0265 13.6615H13.8043",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountrysetup);
export default __webpack_public_path__ + "static/media/countrysetup.c60e2aa47af7e90a6653312244c80eed.svg";
export { ForwardRef as ReactComponent };